import unescapedText from 'I18n/utils/unescapedText';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { getTextContentFromHtml } from 'sanitize-text/sanitizers/TextSanitizer';
import UnreadCountBadge from 'conversations-visitor-experience-components/visitor-widget/spotlight/UnreadCountBadge';
import SpotlightPopupCard, { PopupBodyText } from '../popup-card/SpotlightPopupCard';
import SpotlightPopupHeader from '../popup-card/SpotlightPopupHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const SpotlightWelcomeMessagePopup = ({
  agentName,
  agentAvatarUrl,
  isBot,
  isResponderAI,
  messageText,
  isDismissing,
  width,
  onDismiss,
  onDismissAnimationEnd,
  onOpen
}) => /*#__PURE__*/_jsx(SpotlightPopupCard, {
  width: width,
  isDismissing: isDismissing,
  ariaLabel: unescapedText('conversations-visitor-ui.spotlight.welcomeMessagePopup.dialogLabel'),
  dismissAriaLabel: unescapedText('conversations-visitor-ui.spotlight.welcomeMessagePopup.dismiss'),
  testId: "spotlight-welcome-message-popup",
  onDismiss: onDismiss,
  onDismissAnimationEnd: onDismissAnimationEnd,
  onOpen: onOpen,
  announcementText: getTextContentFromHtml(messageText),
  badge: /*#__PURE__*/_jsx(UnreadCountBadge, {
    count: 1
  }),
  children: /*#__PURE__*/_jsx(SpotlightPopupHeader, {
    avatarUrl: agentAvatarUrl,
    avatarName: agentName,
    isBot: isBot,
    isResponderAI: isResponderAI,
    nameLine: agentName,
    children: /*#__PURE__*/_jsx(PopupBodyText, {
      dangerouslySetInnerHTML: {
        __html: formatHtml(messageText)
      }
    })
  })
});
SpotlightWelcomeMessagePopup.displayName = 'SpotlightWelcomeMessagePopup';
export default SpotlightWelcomeMessagePopup;